import { createRequestTypes } from '../../utils';

// export const NEW_FORMULA_REVIEW_WIZARD = 'formulaReviewWizard/NEW_FORMULA_REVIEW_WIZARD';
export const EDIT_FORMULA_REVIEW_WIZARD = createRequestTypes('formulaReviewWizard/EDIT_FORMULA_REVIEW_WIZARD');
export const NEW_FORMULA_REVIEW_WIZARD = createRequestTypes('formulaReviewWizard/NEW_FORMULA_REVIEW_WIZARD');
export const LOAD_FORMULA_REVIEW_DATA = 'formulaReviewWizard/LOAD_FORMULA_REVIEW_DATA';
export const UPDATE_FORMULA_REVIEW = 'formulaReviewWizard/UPDATE_FORMULA_REVIEW';
export const SAVE_FORMULA_REVIEW = 'formulaReviewWizard/SAVE_FORMULA_REVIEW';
